import { svgIconTypes } from 'zaions-tool-kit';
import { formFieldsConstants } from '../formFields';
import { IMAGE_CONFIG } from '../generic';

const GENERAL = {
  RELOAD_DATA: 'Reload Data',
  FILE_SIZE_LIMIT: `File size has exceeded it's max limit of ${IMAGE_CONFIG.SIZE_LIMIT_MB}MB`,
  INVALID_FILE_TYPE: `Invalid file type selected. Allowed file types are ${IMAGE_CONFIG.ALLOWED_IMAGE_TYPES}.`,
  INVALID_FILE: 'Invalid file selected. Please try again.',
  INVALID_PHONE: 'Please enter valid Phone No.',
  THANKS_FOR_FEEDBACK: 'Thank you for the feedback.',
  CHAR_LIMIT_EXCEEDED: (prop: string | number): string =>
    `${prop} limit exceeded ${formFieldsConstants.testArea.max
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} characters`,
  SPECIAL_CHARS_NOT_ALLOWED: 'Special characters are not allowed.',
  SPECIAL_CHARS_AND_SPACES_NOT_ALLOWED:
    'Special characters and spaces are not allowed.',
  IMAGE_REQUIRED: 'Image is required.',
  INVALID_URL: 'Please enter a valid URL',
  AFFILIATE_LINK_WARNING:
    'Please ensure this is not an affiliate link. See Perkforce Terms & Conditions for more details',
  INVALID_REQUEST: 'Invalid request.',
  ERROR_OCCURRED: 'Error occurred, try again later',
  CANCELLED_BY_USER: 'Request cancelled by user.',
  ACCEPT_CONDITION: 'Please accept the condition.',
  REQUEST_EXPIRED: 'Requested token expired, try again later.',
  INVALID_EMPLOYEE_PERMISSIONS:
    'Invalid request. Your permissions are changed. Please refresh your page.',
  INVALID_ICON_TYPE: (type: string = 'svg'): string =>
    `Invalid file type selected. Allowed file types are ${
      type === 'svg'
        ? svgIconTypes.join(', ')
        : IMAGE_CONFIG.ALLOWED_IMAGE_TYPES
    }.`,
  GIVE_FEEDBACK: 'Give Feedback',
  COLLEGE: 'College',
  BUSINESS: 'Business',
  COMPANY: 'Company',
  COMPANY_OR_COLLEGE: 'Company or College',
  SUCCESS: 'Request completed successfully.',
  NAME_REQUIRED: 'Name is required.',
  ID_REQUIRED: "Id is required, can't proceed without id.",
  REMARKS_MAX_ERROR: `Remarks must contain at most ${formFieldsConstants.remarks.max} character(s)`,
  REMARKS_REQUIRED: 'Remarks is required.',
  INVALID: 'Invalid request.',
  EMAIL_EXISTS: 'Email address already occupied.',
  CARD_BANNER_NOT_FOUND: 'Card or Banner not found.',
  PERKS_SENT: 'Perks Sent.',
  DB_CONNECTED: 'Database Connected Successfully.',
  UNAUTHENTICATED: 'please authenticate',
  SPECIAL_CHARACTERS_NOT_ALLOWED:
    'Please provide a valid value, Special characters are not allowed.',
  CHARATCER_LIMIT_EXCEEDED: 'Characters Limit Exceeded.',
  FILE_UPLOAD_SUCCESS: 'File upload completed successfully.',
  FILE_UPLOAD_FAILED: 'File upload failed.',
  NOT_FOUND: 'Item not found.',
  INVALID_SLUG:
    'Invalid category name, name should contain at least one alphabet and should be unique.',
  INVALID_EMAIL: 'Please provide a valid email address.',
  UNAUTHORIZED:
    'Unauthorized access. You do not have permission to perform this action. Please check your credentials or contact support if you believe this is a mistake.',
  UNEXPECTED_ERROR_MESSAGE: 'An unexpected error occurred. Please try again.',
  DEPRECATION_REASON_REQUIRED: 'Deprecated reason is required.',
} as const;

export default GENERAL;
